.warning {
  margin-top: 29px;
  padding: 0 15px;

  .items {
    list-style-type: disc;
    color: #7b766f;
  }

  .item {
    margin-top: 6px;

    &:first-child {
      margin-top: 0;
    }

    a {
      text-decoration: underline;
    }

    p {
      color: #7b766f;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.045px;

    }
  }
}
